import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
// import { motion } from "framer-motion";
import Button  from "@/components/ui/Button";
import Input  from "@/components/ui/Input";
import { environment } from '@/environments/environment';
import {
Form,
FormControl, 
FormField,
FormItem,
FormLabel,
FormMessage,
} from "@/components/ui/Form";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/Card";
import apiRequest from "@/services/requests";

const LoginPage = () => {
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const navigate = useNavigate();

const form = useForm({
defaultValues: {
username: "",
password: "",
},
});
 

const handleLogin = async (data) => {
try {
const response = await apiRequest.login(data.username, data.password);
localStorage.setItem('token', response.token);
localStorage.setItem('isOnboarded',response.isOnboarded);
// console.log(response)
if(response.isOnboarded === true){
navigate('/'); 
}else{
navigate('/onboarding'); 
} 
} catch (error) {

// console.log(error.status)	
// Handle different error statuses
if (error.status === 404) {
toast.error('Invalid credentials', {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
});
} else if (error.status === 500) {
toast.error('Server error, please try again later', {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
});
} else {
toast.error('An unexpected error occurred', {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
});
}
}
};





return (
<div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
{/* Left Side - Hero */}
<div className="hidden lg:flex flex-col justify-between bg-black p-12 text-primary-foreground relative overflow-hidden">
{/* Abstract Background Patterns */}
<div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
<div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full bg-white blur-3xl" />
<div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full bg-white blur-3xl" />
</div>

<div className="relative z-10 flex items-center gap-2 text-2xl font-bold font-display">
<img
src="/assets/images/aplini-dark.webp"
alt="Aplini logo"
className="w-28 h-auto object-contain"
width="116" height="32"
/>
</div>


<div className="relative z-10">
<h1 
// className="text-4xl text-white font-bold mb-6 font-display leading-tight"
style={{ fontSize:"clamp(34px,6vw,66px)",fontWeight:900,lineHeight:1.1,letterSpacing:"-0.03em",marginBottom:20,color:"#ffffff" }}
>
Level up your career <br/> <span style={{ background:"linear-gradient(135deg,#f59e0b,#f97316)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text" }}>in 90 days.</span>
</h1>
<p 
// className="text-lg text-primary-foreground/80 max-w-md"
style={{ fontSize: "clamp(18px, 2.5vw, 24px)", color: "#a0a0b8", lineHeight: 1.6, marginBottom: 48, maxWidth: 680,  }}
>
The most powerful program for ambitious professionals. Career growth guidance, analytics, and interview preps all in one place.
</p>
</div>

<div className="relative z-10 text-sm text-primary-foreground/60">
© 2026 Aplini Ltd. All rights reserved.
</div>
</div>
{/*flex items-center justify-center*/}

{/* Right Side - Form */}
<div className="px-4 flex flex-col justify-center lg:p-8 bg-background">

<div className="lg:hidden relative z-10 flex items-end justify-center gap-2 font-bold font-display w-full  flex-[0.2] pb-6">
<img
src="/assets/images/aplini-logo.webp"
alt="Aplini logo"
className="w-28 h-auto object-contain"
width="116" height="32"
/>
</div>

<div className="flex-1 flex items-start lg:items-center justify-center">
<div className="w-full max-w-md">
<Card className="border-none shadow-none lg:border lg:shadow-xl">
<CardHeader className="space-y-1">
<CardTitle className="text-2xl font-bold font-display">Welcome back</CardTitle>
<CardDescription>
Enter your credentials to access your dashboard
</CardDescription>
</CardHeader>
<CardContent>


<Form {...form}>
<form onSubmit={form.handleSubmit(handleLogin)} className="space-y-4">
<FormField
control={form.control}
name="username"
render={({ field }) => (
<FormItem>
<FormLabel>Username</FormLabel>
<FormControl>
<Input 
placeholder="johndoe"
{...field} 
className="h-11 rounded-xl border border-gray-300"
/>
</FormControl>
<FormMessage />
</FormItem>
)}
/>

<FormField
control={form.control}
name="password"
render={({ field }) => (
<FormItem>
<FormLabel>Password</FormLabel>
<FormControl>
<Input 
type="password" 
placeholder="••••••••" 
{...field} 
className="h-11 rounded-xl border border-gray-300"
/>
</FormControl>
<FormMessage />
</FormItem>
)}
/>


<button
type="submit"
// className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
style={{ display:"inline-flex",alignItems:"center",justifyContent:"center",gap:10,padding:"16px 36px",background:"linear-gradient(135deg,#f59e0b 0%,#f97316 100%)",border:"none",borderRadius:12,color:"#0f0f0f",fontSize:16,fontWeight:900,cursor:"pointer",letterSpacing:"0.01em",fontFamily:"system-ui,sans-serif",position:"relative",overflow:"hidden",boxShadow:"0 0 40px rgba(245,158,11,0.45),0 4px 20px rgba(0,0,0,0.3)",transition:"transform .15s ease,filter .15s ease",textTransform:"capitalize", width:'100%' }}
disabled={form.formState.isSubmitting}
>
<span style={{ position:"absolute",top:0,left:0,width:"100%",height:"100%",background:"linear-gradient(90deg,transparent,rgba(255,255,255,0.25),transparent)",animation:"shimmer 8.4s linear infinite",pointerEvents:"none" }} />
<span className="absolute left-0 inset-y-0 flex items-center pl-3">
<svg className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
<path
fillRule="evenodd"
d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
clipRule="evenodd"
/>
</svg>
</span>

{form.formState.isSubmitting ? (
<>
<Loader2 className="mr-2 h-4 w-4 animate-spin" />
Signing in...
</>
) : (
"Sign In"
)}

</button>

</form> 
</Form>


</CardContent>

<CardFooter className="flex flex-col gap-4 text-center text-sm text-muted-foreground">
<div className="relative w-full">
<div className="absolute inset-0 flex items-center">
<span className="w-full border-t" />
</div>
<div className="relative flex justify-center text-xs uppercase">
<span className="bg-background px-2 text-muted-foreground">
Or
</span>
</div>
</div>
<p>
Don't have an account?{" "}
<a 
href={environment.webUrl + 'signup'}
className="text-blue-500 font-semibold hover:underline capitalize">
Signup
</a>
</p>
</CardFooter>

</Card>
</div>
</div>




</div>


</div>
);
};

export default LoginPage;